<template>
  <a class="text-decoration-none" href="/terms-of-service" target="_blank"> Terms of
    Service <v-icon color="primary" small>mdi-open-in-new</v-icon></a>
</template>
<script>
export default {
  name: "TermsOfServiceLink",
}
</script>